import {elementNameConst, shapeTypeConst} from '../../../conf';

/**
 * 拓扑插件-自定义单控制节点单弧度虚线动画曲线-扩展
 */
export default {
  name: shapeTypeConst.quadraticDashRunning,
  type: elementNameConst.edge,
  options: {
    /**
     * 绘制后的附加操作，默认没有任何操作
     * @param cfg 边的配置项
     * @param group 图形分组，边中的图形对象的容器
     */
    afterDraw(cfg, group) {

      // 获得组中的第一个形状，这是边的路径=
      const shape = group.getFirst();
      let index = 0;

      // 动画配置
      const animateCfg = {
        // 是否重复执行动画
        repeat: true,
        // 执行一次的持续时间
        duration: 3000 
      };

      // 线条虚线样式
      const lineDash = [4, 2, 1, 2];

      // 红色圆圈的动画
      shape.animate(() => {
        index++;
        if (index > 9) {
          index = 0;
        }
        // 此处返回修改后的配置，此处返回lineDash和lineDashOffset
        return { lineDash, lineDashOffset: -index };
      }, animateCfg);
    }
  },
  // 继承节点名
  extendedNodeName: shapeTypeConst.quadratic
};
